import React, { useState, Fragment, useEffect } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Select, Table, notification } from 'antd';
import { QUANTITY } from '@Apis/constants';
import H3Text from '@Uilib/h3Text';
import H3FormInput from '@Uilib/h3FormInput';

import ReservationActions from '@Actions/reservationActions';
import './style.scss';

const { Option } = Select;

const UpdateReservation = ({ order, mrpId, callback, getReservation, getReservationLoading, reservation, MONEY, createReservation, createReservationLoading, updateFreeReservation, updateFreeReservationLoading, entityId, entityType, entityLineId, entityLineType, productName, productSkuId, productInternalSkuCode }) => {
  const [call, setCall] = useState(false);
  const [reserveData, setReserveData] = useState([]);
  const [unreserveData, setUnreserveData] = useState([])
  const [formSubmitted, setFormSubmitted] = useState(false);

  // useEffect(() => {
  //   setReserveData(order?.reserved_batches);
  // }, []);

  useEffect(() => {
    getReservation({ entityLineType: entityLineType, entityLineId: entityLineId, tenantProductId: order?.tenant_product_id }, (_reservation) => {
      setReserveData(_reservation?.reserved_batches);

      let toBeOrderQty = Number(order?.pending_quantity);
      let otherBatch = _reservation?.other_batches;

      let copyOtherBatch = otherBatch?.filter((item) => QUANTITY(item?.available_qty || 0, item?.uom_info?.[0]?.precision) > 0)?.map((batch) => {
        let maxReserveQty = Number((batch?.available_qty || 0) - (batch?.total_reserved_qty || 0));
        if (toBeOrderQty > 0) {
          batch.reserved_quantities = Math.min(toBeOrderQty, maxReserveQty);
          toBeOrderQty -= Number(batch?.available_qty - batch?.total_reserved_qty);
        } else {
          batch.reserved_quantities = 0;
        }
        return batch;
      })

      setUnreserveData(copyOtherBatch);
    })
  }, [call]);
  const handleCreateReservation = (batchData) => {
    setFormSubmitted(true);
    if ((Number(batchData?.reserved_quantities) <= Number(batchData?.available_qty - batchData?.total_reserved_qty)) && Number(batchData?.reserved_quantities) > 0) {
      const payload = [{
        batch_id: batchData?.batch_id,
        tenant_product_id: order?.tenant_product_id,
        tenant_id: batchData?.tenant_id,
        product_sku_id: batchData?.product_sku_id,
        reserved_qty: batchData?.reserved_quantities,
        consumed_qty: 0,
        reservation_entity_name: entityType,
        reservation_entity_id: entityId,
        reservation_entity_line_name: entityLineType,
        reservation_entity_line_id: entityLineId,
        mrp_id: Number(mrpId),
      }];

      createReservation(payload, () => {
        setCall(!call);
        callback();
        setFormSubmitted(false);
      })
    } else {
      notification.error({
        message: 'Reserve Quantity cannot be more than Available Quantity',
        placement: 'top',
        duration: 4,
      });
    }
  }

  const getreservationColumns = () => {
    let columns = [
      {
        title: 'Batch#',
        fixed: 'left',
        width: '150px',
        render: (record) => (
          <Fragment>
            <div>{`${record?.custom_batch_number || record?.batch_number}`}</div>
            <div style={{ fontWeight: '600' }}>{record?.department_name}</div>
          </Fragment >
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Lot#',
        width: '150px',
        render: (record) => (
          <Fragment>
            <div>{`${record?.lot_number || '-'}`}</div>
          </Fragment >
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Cost Price',
        render: (record) => (
          <Fragment>
            <div>{MONEY(record?.cost_price || 0)}</div>
          </Fragment >
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Landed Price',
        render: (record) => (
          <Fragment>
            <div>{MONEY(record?.landed_cost || 0)}</div>
          </Fragment >
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Reserved Qty',
        render: (record) => (
          <Fragment>
            <div>
              {`${QUANTITY(record?.reserved_qty || 0, record?.uom_info?.[0]?.precision)} ${record?.uom_info?.[0]?.uqc?.toProperCase() || ''}`}
            </div>
          </Fragment >
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'On Hand Qty',
        render: (record) => (
          <Fragment>
            <div>
              {`${QUANTITY(record?.available_qty || 0, record?.uom_info?.[0]?.precision)} ${record?.uom_info?.[0]?.uqc?.toProperCase() || ''}`}
            </div>
          </Fragment >
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Available Qty',
        render: (record) => (
          <Fragment>
            <div>
              {`${QUANTITY(((record?.available_qty || 0) - (record?.total_reserved_qty || 0)) || 0, record?.uom_info?.[0]?.precision)} ${record?.uom_info?.[0]?.uqc?.toProperCase() || ''}`}
            </div>
          </Fragment >
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Reserve Qty',
        width: '100px',
        render: (record) => (
          <Fragment>
            <div>
              <H3FormInput
                value={record.reserved_quantities}
                type="number"
                containerClassName={`${formSubmitted && (Number(record.reserved_quantities) <= 0 || Number(record.reserved_quantities) > Number(record?.available_qty - record?.total_reserved_qty))
                  ? 'create-pr__input'
                  : ''
                  }`}
                labelClassName="orgFormLabel"
                inputClassName="orgFormInput"
                onChange={(e) => {
                  const copyData = JSON.parse(JSON.stringify(unreserveData));
                  copyData.map((item) => {
                    if (item.batch_id === record.batch_id) {
                      item.reserved_quantities = e.target.value;
                    }
                    return unreserveData;
                  });
                  setUnreserveData(copyData);
                }}
                required
                showError={formSubmitted && !record.reserved_quantities}
              />
            </div>
          </Fragment >
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: ' ',
        fixed: 'right',
        width: '90px',
        render: (record) => (
          <Fragment>
            <div className="update-reservation__reserve-btn" onClick={() => updateFreeReservation([{ reservation_id: record?.reservation_id }], () => {
              setCall(!call);
              callback();
            })}>
              <div style={{ padding: '3px' }}>
                Unreserve
              </div>
            </div>
          </Fragment >
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: '',
        fixed: 'right',
        width: '90px',
        render: (record) => (
          <Fragment>
            <div className="update-reservation__reserve-btn" onClick={() => handleCreateReservation(record)}>
              <div style={{ padding: '3px' }}>
                Reserve
              </div>
            </div>
          </Fragment >
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      }
    ];

    return columns;
  };

  const getReserveDataSource = () => {
    const copyReserveData = JSON.parse(JSON.stringify(reserveData || []));
    return copyReserveData;
  }

  const getUnreserveDataSource = () => {
    const copyUnreserveData = JSON.parse(JSON.stringify(unreserveData || []));
    return copyUnreserveData;
  }

  return (
    <Fragment>
      <div className="update-reservation__wrapper">
        <div className="update-reservation__header-wrapper">
          <Link to={`/inventory/product/view/${productSkuId}?tab=1`} target="_blank">
            <H3Text text={`#${productInternalSkuCode} ${productName}`} className="update-reservation__product-name" />
          </Link>
        </div>
        <div className="update-reservation__body-wrapper">
          <div className="update-reservation__table-upper">
            <Table
              title={() => (
                <div className="material-shortage__table-title__wrapper">
                  <H3Text text={`${getReserveDataSource()?.length || '0'} Reserved Batches`} className="" />
                </div>
              )}
              bordered
              loading={getReservationLoading}
              showHeader
              size="small"
              scroll={{ x: 'max-content' }}
              dataSource={getReserveDataSource() || []}
              columns={getreservationColumns()?.filter((item) => !["Available Qty", "Reserve Qty", ""].includes(item?.title))}
              pagination={false}
            />
          </div>
          <div className="update-reservation__table-lower">
            <Table
              title={() => (
                <div className="material-shortage__table-title__wrapper">
                  <H3Text text={`${getUnreserveDataSource()?.length || '0'} Unreserved Batches`} className="" />
                </div>
              )}
              bordered
              loading={getReservationLoading}
              showHeader
              size="small"
              scroll={{ x: 'max-content' }}
              dataSource={getUnreserveDataSource() || []}
              columns={getreservationColumns()?.filter((item) => !["Reserved Qty", " "].includes(item?.title))}
              pagination={false}
            />
          </div>
        </div>
      </div>
    </Fragment>
  )
}

const mapStateToProps = ({
  UserReducers, ReservationReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  reservation: ReservationReducers.reservation,
  getReservationLoading: ReservationReducers.getReservationLoading,
  createReservationLoading: ReservationReducers.createReservationLoading,
  updateFreeReservationLoading: ReservationReducers.updateFreeReservationLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getReservation: (payload, callback) => dispatch(ReservationActions.getReservation(payload, callback)),
  createReservation: (payload, callback) => dispatch(ReservationActions.createReservation(payload, callback)),
  updateFreeReservation: (payload, callback) => dispatch(ReservationActions.updateFreeReservation(payload, callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(UpdateReservation));